/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
  Box,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";

import { connect } from "react-redux";
import { loginUser, loadUser } from "../../actions/AuthActions";
import axios from "../../CustomAxios";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function CustomerUser({
  setEmail,
  loginUser,
  auths,
  loadUser,
  setState,
  setVerification,
  setOtp,
}) {
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  React.useEffect(async () => {
    if (!auths.token) {
      navigate("/login");
    } else {
      const data = await loadUser();
      if (!data.success) {
        navigate("/login");
      } else {
        const userData = JSON.parse(localStorage.getItem("AuthData"));
        if (userData.type === "customer_user") {
          navigate("/dashboard/stats");
        } else {
          navigate("/dashboard/tasks");
        }
      }
    }
  }, []);

  const login = async (user) => {
    try {
      const { data } = await axios.post(`/api/v1/customer_user/auth/login`, {
        email_address: user.email_address,
        password: user.password,
      });
      if (data.success) {
        setVerification(data.verification_key);
        setOtp(data.otp_code);
        setState(1);
        setEmail(user.email_address);
      }
    } catch (e) {
      console.log(e);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
    }
  };

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const user = {
            email_address: values.email,
            password: values.password,
            type: "customer_user",
          };
          login(user);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={3} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {err ? (
            <Alert mt={2} mb={3} severity="error">
              {err}
            </Alert>
          ) : null}

          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <TextField
            data-testid="password"
            type="password"
            name="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <Button
            data-testid="submit-button"
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Signing In &nbsp;
                <CircularProgress size={20} color="primary" />
              </>
            ) : (
              "Sign in"
            )}
          </Button>
          <Box
            component={"span"}
            m={1}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              data-testid="ap-button"
              component={Link}
              to="/login/ap-user"
              color="primary"
            >
              Login as AP User
            </Button>
            <Button
              data-testid="forgot-button"
              style={{ textAlign: "right" }}
              component={Link}
              to="/reset-password?user=customer_user"
              color="primary"
            >
              Forgot password
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}

CustomerUser.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auths: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { loginUser, loadUser })(CustomerUser);
